/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalProfileController', PersonalProfileController);

    PersonalProfileController.$inject = ['PrincipalProfile', 'Auth', 'JhiLanguageService', '$translate', 'AlertService'];

    function PersonalProfileController (PrincipalProfile, Auth, JhiLanguageService, $translate, AlertService) {

        var vm = this;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            if (vm.profile.nickname) {
                vm.profile.nickname = vm.profile.nickname.trim();
            }
            if (vm.profile.nickname === vm.profile.user.firstName || vm.profile.nickname === "") {
                vm.profile.nickname = null;
            }
            Auth.updateProfile(vm.profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.profile.user.langKey !== current) {
                        $translate.use(vm.profile.user.langKey);
                    }
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();
